<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div style="width: 100%; height: 100%" :id="data['id'] + 'oee-monthly-bar'"></div>
    </dv-border-box-7>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "oee-monthly-total",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
    updateTime: {
      type: Number,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      data: this.bean,
      current: {},
      option: {},
      refreshTime: null,
    };
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        this.data = val;
        this.formatData();
      },
      deep: true,
    },
    updateTime: function (val, oldVal) {
      this.refreshTime = format(val, "HH:mm:ss");
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) { 
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },

    formatData() {
      var data = this.data;
      var value = data["value"] || 0;
      var weekList = data["weekList"];
      var minTitle = data["minTitle"];
      var kpi = data["kpi"] || 95;
      var color = value >= kpi ? "#00E690" : "red";

      this.option = {
        series: [
          {
            center: ["50%", "50%"],
            radius: "70%",
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 18,
            data: [
              {
                name: data["id"],
                value: value,
                gradient: [color],
              },
            ],
            dataItemStyle: {
              fill: "#FFF",
              fontSize: 13,
              textAlign: "right",
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            backgroundArc: {
              show: true,
              style: {
                fill: "#0B2140",
                stroke: "#0B2140",
              },
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              formatter: "{value}%",
              style: {
                fill: "#fff",
                fontSize: 65,
                fontFamily: "electronicFont",
              },
            },
          },
        ],
      };

      var barOpt = this.$echarts.init(
        document.getElementById(data["id"] + "oee-monthly-bar")
      );

      const xAxis = [];
      const lineData = [];
      const lineKpi = [];

      weekList.forEach((item) => {
        xAxis.push(item.week);
        if (data["id"] == "oee") {
          lineData.push(Math.round(item.oee));
          lineKpi.push(item.oeeKpi);
        } else {
          lineData.push(Math.round(item.ftq));
          lineKpi.push(item.ftqKpi);
        }
      });

      var option2 = {
        title: {
          text: minTitle,
          left: "center",
          textStyle: {
            color: "#ffffff",
            fontSize: "24",
          },
        },
        grid: {
          bottom: 25,
          top: 35,
          x: 40,
          y: 50,
          left: 60,
        },
        xAxis: [
          {
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 13,
              },
              interval: 0,
            },
          },
        ],
        yAxis: [
          { name:"%",
		  nameGap: 5,
            type: "value",
            min: 0,
            axisLabel: {
            //  formatter: "{value} %",
			formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                type: "dashed", //虚线
              },
              show: true, //隐藏
            },
            //  interval: 30,
            axisLine: {
              show: true,
              symbolOffset: 10,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        label: {
          show: true,
          position: "inside",
          style: {
            fontSize: 10,
          },
          // formatter: (params) => {
          //   return params.value + "%";
          // },
        },
        series: [
          {
            name: "实际",
            type: "bar",
            data: lineData,
            barWidth: 30,
            barGap: "-100%",
            itemStyle: {
              normal: {
                color: function (params) {
                  return params["value"] >= lineKpi[0] ? "#00E690" : "red";
                },
              },
            },
            color: "red",
            markLine: {
              symbol: ["none", "none"], //去掉箭头
              lineStyle: {
                type: "dashed",
                normal: {
                  type: "solid",
                  color: "#00E690 ", // 这儿设置安全基线颜色
                },
              },
              data: [
                {
                  yAxis: lineKpi[0],
                },
              ],
              label: {
                show: true,
				distance: [-20, 0],
                position: "insideStartBottom",
                color: "#00E690",
              },
            },
          },
        ],
      };

      barOpt.setOption(option2);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style>
.piebg {
  background: url("../../../../assets/img/oee/piebg.png") no-repeat center center;
  background-size: 100%;
}
</style>
<style scoped src='../board.css'>
</style>




// WEBPACK FOOTER //
// src/pages/oee/monthly/component/oee-monthly-total.vue